import { PPLX_VISITOR_ID_COOKIE } from '#pplx/frontend/cookies/constants.js';
import { getCookie } from '#pplx/frontend/cookies/provider.js';
import { REQUEST_ID_HEADER } from '#pplx/frontend/fetcher/constants.js';
import { fetchWithTimeout as httpFetch } from '#pplx/frontend/fetcher/core.js';
const SEARCH_NAVIGATE_V2_URL = 'https://suggest.perplexity.ai/search/v2/navigate';
const isJsonContentType = (contentType) => contentType?.toLowerCase().includes('json') ?? false;
const parseNavigationalSearchResponse = async (response) => {
    if (!response.ok) {
        return undefined;
    }
    const responseText = await response.text();
    if (!responseText.trim()) {
        return undefined;
    }
    const contentType = response.headers.get('content-type');
    if (contentType && !isJsonContentType(contentType)) {
        return undefined;
    }
    try {
        return JSON.parse(responseText);
    }
    catch {
        return undefined;
    }
};
export const fetchNavigationalSearchV2 = async ({ query, reason, streamId, streamTimer, userIdentity, }) => {
    streamTimer?.addTimingOnce('web.frontend.v2_navigation_request_sent_ms');
    // SAPI v2 reads locale from the body for web (Accept-Language/X-Country only for Android).
    const body = {
        query,
        user_identity: {
            lang: userIdentity.lang,
            ...(userIdentity.country && { country: userIdentity.country }),
            ab_active_tests: userIdentity.ab_active_tests ?? [],
        },
    };
    const visitorId = getCookie(PPLX_VISITOR_ID_COOKIE);
    const response = await httpFetch({
        resource: SEARCH_NAVIGATE_V2_URL,
        method: 'POST',
        options: {
            headers: {
                'content-type': 'application/json',
                'X-Client-Name': 'agi_ui_navigate_v2',
                'X-Client-Env': 'production',
                ...(streamId && { [REQUEST_ID_HEADER]: streamId }),
                ...(visitorId && { 'X-Visitor-Id': visitorId }),
            },
        },
        body: JSON.stringify(body),
        timeoutMs: 1000,
        reason,
    });
    streamTimer?.addTimingOnce('web.frontend.v2_navigation_results_received_ms');
    return parseNavigationalSearchResponse(response);
};
//# sourceMappingURL=fetchNavigationalSearchV2.js.map